import { Component, Injector, OnInit, ViewChild, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { CR, idNameItem, jkAlert, JkBaseOption, jkGlb, MaterialModule, OpenWinLoadOption, PageKind, } from 'jk-service';
import { JkgridwinComponent, jkQueryComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { RowClickedEvent } from 'ag-grid-community';
import { SqlWhereCondition } from '../components/sql-where/sql-where.component';

import { JkeditComponent, openWinClass } from 'jk-service';
import { DefineWhereComponent } from '../components/define-where/define-where.component';
import { AdvComModule } from 'jk-advcom';

export class Utyq01Option extends JkBaseOption { // ###
  Title = '';// customId
  PS: string = '';
  orderBy: string = 'ORDER BY ITEM';

}

@Component({
  standalone: true,
  selector: 'app-utyq01',
  templateUrl: './utyq01.component.html',
  imports: [MaterialModule, AdvComModule, JackBaseComponentModule, DefineWhereComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class Utyq01Component extends jkQueryComponent implements OnInit {
  override _programId = 'utyq01'; // ###
  isPvi: boolean = false;
  filterOpt: Utyq01Option = new Utyq01Option(this.programId);//###
  constructor() {
    super();
    //this.setFormOpt2();//###
    this.filterOpt.orderBy = this.orderList[0].id; // 'ORDER BY MainTable,ITEM';
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.login.dbname === 'Y_RELEASED' || this.login.dbname === 'V_RELEASED') {
      this.isPvi = true;
      console.log('isPvi', this.isPvi);
    } else {
      this.isPvi = false;
    }

    this.checkAllInit(this);// 這行要放在 ngAfterViewInit 最後  ###
    try {
      //await this.masterLookup.init();
      setTimeout(() => {
        this.doQuery();
      }, 10);
    } catch (error) {

    }

  }
  ngOnExit() {
  }
  userWhere: string = '';
  defineOrderList: idNameItem[] = [];
  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    //await this.masterGrid.init(this.programId,'S01','S',['LG001','LG002','LG003','LG004'],[]);
    this.gridInitOpt = {
      pageKind: PageKind.report,
      programId: this.programId,
      sortField: '',
      sort: 'asc',
      defaultSort: null,
    };
    this.type = 'S';
    this.winItem = 'S01';
    this.mainTable = 'UTYQ01';
    this.where = '';
    this.userWhere = '';
    if (this.isPvi) { // jkGlb.env.appId.toUpperCase() === 'PVI'
      this.where += ` AND MainTable = 'PVI' `;
    };
    this.where += ` AND ((SA003 = '${this.uid}') OR (SA003 = '*')) `;
    if (this.filterOpt.Title !== '')
      this.where += ` AND Title LIKE '%${this.filterOpt.Title}%'`;
    if (this.filterOpt.PS !== '')
      this.where += ` AND PS LIKE '%${this.filterOpt.PS}%'`;
    this.order = this.filterOpt.orderBy;
    return true;
  }

  // ### [以上是必要的]================================
  defineGrid!: JkgridwinComponent;
  orderList: idNameItem[] = [{ 'id': 'ORDER BY MainTable,ITEM', 'name': '序號' }, { 'id': 'ORDER BY Title', 'name': '標題' }];
  readonly titleCom = viewChild.required<JkeditComponent>('title');
  readonly psCom = viewChild.required<JkeditComponent>('ps');
  // TODO: Skipped for migration because:
  //  Your application code writes to the query. This prevents migration.
  // TODO: Skipped for migration because:
  //  Your application code writes to the query. This prevents migration.
  //@ViewChild('defineWhere')
  defineWhereCom!: DefineWhereComponent;
  WhereList: SqlWhereCondition[] = [];
  defineWin: openWinClass = new openWinClass();
  rowData: any;
  //createUserID: string = '';

  querySelect($event: RowClickedEvent<any, any>) {

    this.rowData = $event.data;
    if (this.defineGrid) {
      this.defineGrid.excelFileName = this.rowData.Title;
    }

    if (this.isPvi) { // jkGlb.env.appId.toUpperCase() === 'PVI'
      this.defineWin.mainTable = 'PVI';

    } else {
      this.defineWin.mainTable = this.rowData.MainTable;
    }
    this.initDefineOrderList(this.rowData.SQLOrder);
    this.defineWin.item = this.rowData.ITEM;
    this.defineWin.type = 'U'; // this.rowData.TYPE;
    this.defineWin.where = this.rowData.SQLWhere;
    this.defineWin.sqlSelect = this.rowData.SQLSelect;
    this.defineWin.display = this.rowData.Display;
    this.defineWin.sqlOrder = this.rowData.SQLOrder;
    this.defineWin.map = this.rowData.MAP;
    this.defineWin.PS = this.rowData.PS;
    //this.createUserID = this.rowData.CreateUserID;
    try {
      if (!this.defineWin.map) {
        jkAlert('WHERE 參數設定 未設定');
        return;
      };
      if (!this.defineWin.display) {
        jkAlert('顯示設定(display) 未設定');
        return;
      }
      this.WhereList = JSON.parse(this.defineWin.map);
    } catch (error: any) {
      jkAlert('欄位對應格式有誤:' + error.message + CR + this.defineWin.map);
      this.WhereList = [];
    };
    if (this.masterTabGroupIndex)
      this.masterTabGroupIndex = this.masterTabGroupIndex + 1;
  }
  debugMessage: string[] = [];
  debugText = '';
  goDefineQuery() {
    /*if (!this.createUserID.includes(this.uid)) {
      alert('你沒有權限');
      return;
    }*/
    let where = ''; // this.stklgSrv.sqlWhereDefault;
    this.debugMessage = [];
    try {
      if(!this.defineWhereCom) {
        alert('defineWhereCom is undefined,請先設定 WHERE 參數設定');
        return;
      }
      where = this.defineWhereCom.geneWhere();
      this.defineWin.where += where;
      this.defineWin.where = this.defineWhereCom.replaceParameter(this.defineWin.where);
      this.defineWin.sqlSelect = this.defineWhereCom.replaceParameter(this.defineWin.sqlSelect);
    } catch (error: any) {
      alert('goDefineQuery:' + error.message);
      return;
    }
    if (this.masterTabGroupIndex)
      this.masterTabGroupIndex = this.masterTabGroupIndex + 1;

    // this.defineGrid.doQuery2(this.defineWin.mainTable, this.defineWin.item, this.defineWin.type, this.defineWin.where + this.userWhere + where, this.defineWin.order);
    /*let opt: OpenWinLoadOption = this.defineWin.getOpenWinLoadOption();
    //this.defineGrid.getColumnDefs(opt);
    //        this.orm.parseOpenwin(data, this.openwinColumnDef);
    this.defineGrid.openwinColumnDef.assign(this.defineWin);
    this.defineGrid.setColumnDisplay(this.defineWin);
    this.defineGrid.setOrderList(this.defineWin.order);
    this.defineGrid.doOpenGrid(opt);*/
    this.defineGrid.defineOpenGrid(this.defineWin);
    this.debugMessage.push('sqlSelect:' + this.defineWin.sqlSelect);
    this.debugMessage.push('where:' + this.defineWin.where);
    this.debugMessage.push('OrderBy:' + this.defineWin.order);
    this.debugMessage.push('顯示設定(display):' + this.defineWin.display);
    this.debugMessage.push('WHERE 參數設定 (MAP):' + this.defineWin.map);
    this.debugMessage.push('sqlOrder:' + this.defineWin.sqlOrder);
    this.debugMessage.push('orderList:' + JSON.stringify(this.defineOrderList));
    this.debugText = this.debugMessage.join(CR);

  }
  afterGridReadyDefine($event: JkgridwinComponent) {
    this.defineGrid = $event;
    //this.gridApi = $event.gridApi;
    //this.defineGrid.gridSrv.init(this.gridInitOpt);
    //this.initTabGroup();
  }
  override doComReady($e: any, comName: string) {
    super.doComReady($e, comName);
    console.log('doComReady:', comName);
    if (comName === 'defineWhere') {
      this.defineWhereCom = $e;
      console.log('defineWhereCom:',$e);
    };
  }
  initDefineOrderList(sqlOrder: string) {
    this.defineOrderList = [];
    if (!sqlOrder) return;
    const orders = sqlOrder.split('\n');
    //this.defineOrderList.push({ 'id': '', 'name': '無' });
    orders.forEach(order => {
      const id = order.split(';')[0];
      let name = order.split(';')[1];
      if (!name) {
        name = id;
      };
      this.defineOrderList.push({ 'id': id, 'name': name });
    });
    if (this.defineOrderList.length > 0) {
      this.defineWin.order = this.defineOrderList[0].id;
    }
  }
}
